// نوشته‌هایی که در پلانِ کاغذ به‌اشتباه «دیوار» شده‌اند (برای sketchImport)

const distSeg = (s, x, y) => {
  const dx = s.x2 - s.x1;
  const dy = s.y2 - s.y1;
  const l2 = dx * dx + dy * dy || 1;
  const t = Math.max(0, Math.min(1, ((x - s.x1) * dx + (y - s.y1) * dy) / l2));
  return Math.hypot(s.x1 + dx * t - x, s.y1 + dy * t - y);
};

// کلمه‌ای با خطِ کرسیِ بلند (مثلِ «پذیرایی») گاهی یک یا چند «دیوارِ» کوتاهِ به‌هم‌چسبیده‌ی معلق می‌شود — گروهی که
// کلِ اندازه‌اش کوچک است و هیچ‌جایش به دیوارِ بیرون از گروه نرسیده. این‌ها دیوار نیستند → حذف، و جایشان یک نوشته
export function floatingTextStubs(walls, minSide) {
  const maxLen = minSide * 0.2;
  const tol = minSide * 0.015;
  const n = walls.length;
  const short = walls.map((w) => !w.arc && !w.virtual && Math.hypot(w.x2 - w.x1, w.y2 - w.y1) < maxLen);
  const near = (a, b) =>
    distSeg(b, a.x1, a.y1) <= tol || distSeg(b, a.x2, a.y2) <= tol || distSeg(a, b.x1, b.y1) <= tol || distSeg(a, b.x2, b.y2) <= tol ||
    [1, 2, 3, 4, 5, 6, 7].some((k) => distSeg(b, a.x1 + ((a.x2 - a.x1) * k) / 8, a.y1 + ((a.y2 - a.y1) * k) / 8) <= tol * 0.5);
  const comp = new Int32Array(n).fill(-1);
  const drop = new Set();
  const labels = [];
  for (let s0 = 0; s0 < n; s0 += 1) {
    if (!short[s0] || comp[s0] >= 0) continue;
    const members = [s0];
    comp[s0] = s0;
    let touchesLong = false;
    for (let q = 0; q < members.length; q += 1) {
      const a = walls[members[q]];
      for (let j = 0; j < n; j += 1) {
        if (j === members[q] || comp[j] === s0) continue;
        if (!near(a, walls[j])) continue;
        if (short[j] && comp[j] < 0) {
          comp[j] = s0;
          members.push(j);
        } else touchesLong = true;
      }
    }
    if (touchesLong) continue;
    const xs = members.flatMap((k) => [walls[k].x1, walls[k].x2]);
    const ys = members.flatMap((k) => [walls[k].y1, walls[k].y2]);
    const bx0 = Math.min(...xs);
    const bx1 = Math.max(...xs);
    const by0 = Math.min(...ys);
    const by1 = Math.max(...ys);
    if (Math.max(bx1 - bx0, by1 - by0) >= maxLen) continue;
    members.forEach((k) => drop.add(k));
    const pad = minSide * 0.022;
    const l = { x0: bx0 - pad * 0.3, x1: bx1 + pad * 0.3, y0: Math.min(by0, by1 - pad), y1: Math.max(by1, by0 + pad) };
    l.cx = (l.x0 + l.x1) / 2;
    l.cy = (l.y0 + l.y1) / 2;
    labels.push(l);
  }
  return { walls: walls.filter((_, k) => !drop.has(k)), labels };
}

